import React from 'react';
import './Navbar.css'


export default function Navbar() {
  return (

    <div className='navbar'>
        <h2 className='logo'>Restroguide</h2>
      </div>
   
    
     
      
    

  )
}
